export const ContactData = [
    {
        Title:'Email',
        Info:'ahmedazouz022@gmail.com',
        LinkMail:'https://google.com',
    },
    {
        Title:'Whatsapp',
        Info:'+20 103505324',
        LinkMail:'https://www.facebook.com',
    },
    {
        Title:'Messenger',
        Info:'@ahmed.azouz',
        LinkMail:'https://www.facebook.com/messages/t/100083517627587',
    },
]